import { Expose } from "class-transformer";

export class CreateUserHasVacationDto {
  @Expose()
  userId: string;

  @Expose()
  year: number;
}
